var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.44 8.081a9.515 9.515 0 0 0-1.099-4.008 9.995 9.995 0 0 0-1.81-2.521l.259-.388c.129-.194.129-.453.064-.647a.942.942 0 0 0-.582-.388L14.428 0a.68.68 0 0 0-.582.323c-.13.194-.13.453-.065.647l1.293 2.586c.13.258.323.388.582.388.259.064.453-.065.582-.259l.13-.194C17.53 4.85 18.306 6.53 18.37 8.405c.324 4.46-3.103 8.34-7.564 8.663-4.526.259-8.34-3.103-8.663-7.564-.194-3.039 1.293-5.948 3.879-7.5.517-.323.646-.97.388-1.487A1.032 1.032 0 0 0 5.506 0H5.44c-.13.065-.388.065-.453.13A10.209 10.209 0 0 0 .075 9.567c.13 2.78 1.422 5.237 3.491 7.048 2.004 1.81 4.72 2.715 7.435 2.52 2.78-.193 5.237-1.421 7.047-3.49 1.681-2.199 2.586-4.85 2.392-7.565Z"
  })));
};

export default SvgLoading;